import React, { useEffect } from "react";
import Routers from "./Routes";
import { useSelector } from "react-redux";
import { darkTheme, lightTheme } from "./theme";

const App = () => {
  const themeMode = useSelector((state) => state.theme.mode);

  useEffect(() => {
    const setTheme = themeMode === "lightTheme" ? lightTheme : darkTheme;
    Object.entries(setTheme).forEach(([key, value]) => {
      document.body.style.setProperty(`--${key}`, value);
    });
  }, [themeMode]);

  return <Routers />;
};

export default App;
